var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_2151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 2.1875C18.4706 2.1875 19.3661 2.7002 19.8583 3.54102L34.6239 28.6973C35.123 29.5449 35.123 30.5908 34.6376 31.4385C34.1523 32.2861 33.2431 32.8125 32.2655 32.8125H2.73429C1.75675 32.8125 0.847575 32.2861 0.362223 31.4385C-0.123129 30.5908 -0.116293 29.5381 0.375895 28.6973L15.1415 3.54102C15.6337 2.7002 16.5292 2.1875 17.4999 2.1875ZM17.4999 10.9375C16.5907 10.9375 15.8593 11.6689 15.8593 12.5781V20.2344C15.8593 21.1436 16.5907 21.875 17.4999 21.875C18.4091 21.875 19.1405 21.1436 19.1405 20.2344V12.5781C19.1405 11.6689 18.4091 10.9375 17.4999 10.9375ZM19.6874 26.25C19.6874 25.6698 19.457 25.1134 19.0467 24.7032C18.6365 24.293 18.0801 24.0625 17.4999 24.0625C16.9198 24.0625 16.3634 24.293 15.9531 24.7032C15.5429 25.1134 15.3124 25.6698 15.3124 26.25C15.3124 26.8302 15.5429 27.3866 15.9531 27.7968C16.3634 28.207 16.9198 28.4375 17.4999 28.4375C18.0801 28.4375 18.6365 28.207 19.0467 27.7968C19.457 27.3866 19.6874 26.8302 19.6874 26.25Z",
    fill: "#E5004E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_2151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.8e002568ff3ea08239bd5c8babaadccb.svg";
export { ForwardRef as ReactComponent };